import tr from '@/resources/tr.json';
import { createI18n } from 'vue-i18n';

const messages = {
  en: tr,
};
const i18n = createI18n({
  locale: 'en', // set the default locale
  messages,
});
export default i18n;